import { createAsyncThunk } from "@reduxjs/toolkit";
import { AxiosPropertyInstance, AxiosPaymentInstance } from "../../../common/utils/AxiosInstance";
import { Axios } from "axios";



export const getStatesServices = createAsyncThunk(
   "getStatesServices",
   async (_, { rejectWithValue }) => {
      const URL = "static/states/index.json"
      try {
         const res = await AxiosPropertyInstance.get(URL)

         return { response: JSON.parse(JSON.stringify(res)) }
      } catch (error) {

         return rejectWithValue(JSON.parse(JSON.stringify(error)))
      }
   }
)

export const getDocuments = createAsyncThunk(
   "getDocuments",
   async ({ url }, { rejectWithValue }) => {
      try {
         const res = await AxiosPropertyInstance.get(url)

         return { response: JSON.parse(JSON.stringify(res)) }
      } catch (error) {

         return rejectWithValue(JSON.parse(JSON.stringify(error)))
      }
   }
)


export const getDocumentServices = createAsyncThunk(
   "getDocumentServices",
   async ({ url }, { rejectWithValue }) => {
      try {
         const res = await AxiosPropertyInstance.get(url)

         return { response: JSON.parse(JSON.stringify(res)) }
      } catch (error) {

         return rejectWithValue(JSON.parse(JSON.stringify(error)))
      }
   }
)

export const gedDefaultDocsService = createAsyncThunk(
   "gedDefaultDocsService",
   async ({ url }, { rejectWithValue }) => {
      try {
         const res = await AxiosPropertyInstance.get(url)

         return { response: JSON.parse(JSON.stringify(res)) }
      } catch (error) {

         return rejectWithValue(JSON.parse(JSON.stringify(error)))
      }
   }
)

export const getDocumentForm = createAsyncThunk(
   "getDocumentForm",
   async ({ url }, { rejectWithValue }) => {
      try {
         const res = await AxiosPropertyInstance.get(url)

         return { response: JSON.parse(JSON.stringify(res)) }
      } catch (error) {

         return rejectWithValue(JSON.parse(JSON.stringify(error)))
      }
   }
)

export const getFieldSuggetions = createAsyncThunk(
   "getFieldSuggetions",
   async ({ url, body, method }, { rejectWithValue }) => {
      try {
         if (method === "get") {
            const res = await AxiosPropertyInstance.get(url)
            return { response: JSON.parse(JSON.stringify(res)) }

         } else if (!method || method === 'post') {
            const res = await AxiosPropertyInstance.post(url, body)
            return { response: JSON.parse(JSON.stringify(res)) }
         }
      } catch (error) {

         return rejectWithValue(JSON.parse(JSON.stringify(error)))
      }
   }
)

export const getDocumentFields = createAsyncThunk(
   "getDocumentFields",
   async ({ url }, { rejectWithValue }) => {
      try {
         const res = await AxiosPropertyInstance.get(url)

         return { response: JSON.parse(JSON.stringify(res)) }
      } catch (error) {

         return rejectWithValue(JSON.parse(JSON.stringify(error)))
      }
   }
)

export const serviceCheckout = createAsyncThunk(
  "serviceCheckout",
  async ({ body, type }, { rejectWithValue }) => {
    const token = JSON.parse(localStorage.getItem("token"));
    const url = `/v1/customer/checkout/type/${type}`;
    // const url = '/order/service'

    try {
      const res = await AxiosPaymentInstance.post(url, body, {
        headers: { "x-auth-token": token },
      });

      return { response: JSON.parse(JSON.stringify(res)) };
    } catch (error) {
      const status = error?.response?.status;
      const message = error?.response?.data?.status || "Something went wrong";

      return rejectWithValue({
        status,
        message,
        raw: error?.response?.data,
      });
    }
  }
);

export const getOrders = createAsyncThunk(
   "getOrders",
   async (data, { rejectWithValue }) => {
      const token = JSON.parse(localStorage.getItem("token"))
      const url = '/order/user-orders/overview?pageSize=10&pageIndex=1'


      try {
         const res = await AxiosPaymentInstance.post(url, data, {
            headers: { "x-auth-token": token }
         })

         return { response: JSON.parse(JSON.stringify(res)) }
      } catch (error) {

         return rejectWithValue(JSON.parse(JSON.stringify(error)))
      }
   }
)

export  const getSROPreview= createAsyncThunk('getSROPreview',
   async({body,URL},{rejectWithValue})=>{

     const token = JSON.parse(localStorage.getItem('token'))
     try{
           const res = await AxiosPropertyInstance.post(URL,body,{
            headers:{'x-auth-token':token}
           })
           return {response:JSON.parse(JSON.stringify(res))}
     }
     catch(error){
          return rejectWithValue(JSON.parse(JSON.stringify(error)))
     }
   }
)

export const getDocumentsDetails = createAsyncThunk(
   "getDocumentsDetails",
   async ({ body, URL }, { rejectWithValue }) => {
      const token = JSON.parse(localStorage.getItem("token"))


      try {
         const res = await AxiosPropertyInstance.post(URL, body, {
            headers: { "x-auth-token": token }
         })

         return { response: JSON.parse(JSON.stringify(res)) }
      } catch (error) {

         return rejectWithValue(JSON.parse(JSON.stringify(error)))
      }
   }
)

export const getOrderDetails = createAsyncThunk(
   "getOrderDetails",
   async ({ URL }, { rejectWithValue }) => {
      const token = JSON.parse(localStorage.getItem("token"))
      try {
         const res = await AxiosPaymentInstance.get(URL, {
            headers: { "x-auth-token": token }
         })

         return { response: JSON.parse(JSON.stringify(res)) }
      } catch (error) {

         return rejectWithValue(JSON.parse(JSON.stringify(error)))
      }
   }
)


export const getCreditOptions = createAsyncThunk(
   "getCreditOptions",
   async ({ }, { rejectWithValue }) => {
      const URL = '/static/default/credits.json'
      try {
         const res = await AxiosPropertyInstance.get(URL)

         return { response: JSON.parse(JSON.stringify(res)) }
      } catch (error) {

         return rejectWithValue(JSON.parse(JSON.stringify(error)))
      }
   }
)

export const getRILOrderData = createAsyncThunk(
   "getRILOrderData",
   async ({ secret }, { rejectWithValue }) => {
      const URL = `/order/details?secret=${secret}`
      try {
         const res = await AxiosPaymentInstance.get(URL)

         return { response: JSON.parse(JSON.stringify(res)) }
      } catch (error) {

         return rejectWithValue(JSON.parse(JSON.stringify(error)))
      }
   }
)

export const updateRILOrderData = createAsyncThunk(
   "updateRILOrderData",
   async ({ secret, body }, { rejectWithValue }) => {
      const URL = `/order/details?secret=${secret}`
      try {
         const res = await AxiosPaymentInstance.put(URL, body)

         return { response: JSON.parse(JSON.stringify(res)) }
      } catch (error) {

         return rejectWithValue(JSON.parse(JSON.stringify(error)))
      }
   }
)


export const uploadRILDocument = createAsyncThunk(
   "uploadRILDocument",
   async ({ docFormData }, { rejectWithValue }) => {
      const URL = `/form/file`
      try {
         const res = await AxiosPropertyInstance.post(URL, docFormData)

         return { response: JSON.parse(JSON.stringify(res)) }
      } catch (error) {

         return rejectWithValue(JSON.parse(JSON.stringify(error)))
      }
   }
)

export const uploadRILFormDocument = createAsyncThunk(
   "uploadRILFormDocument",
   async ({ docFormData }, { rejectWithValue }) => {
      const token = JSON.parse(localStorage.getItem("token"));
      const URL = `/form`
      try {
         const res = await AxiosPropertyInstance.post(URL, docFormData, {
            headers: { "x-auth-token": token }
         })

         return { response: JSON.parse(JSON.stringify(res)) }
      } catch (error) {

         return rejectWithValue(JSON.parse(JSON.stringify(error)))
      }
   }
)

export const getAgentServices = createAsyncThunk(
   "getAgentServices",
   async ({ URL }, { rejectWithValue }) => {
      try {
         const res = await AxiosPropertyInstance.get(URL)

         return { response: JSON.parse(JSON.stringify(res)) }
      } catch (error) {

         return rejectWithValue(JSON.parse(JSON.stringify(error)))
      }
   }
)